import { type ReactNode } from 'react'
import { EntraAuthProvider } from './EntraAuthProvider'

export { useAuthContext } from './authContext'
export type { AuthState, AuthContextValue } from './authContext'

export function AuthProvider({ children }: { children: ReactNode }) {
  return <EntraAuthProvider>{children}</EntraAuthProvider>
}
